import React, { useState, useEffect, useContext } from 'react'
import 'reactjs-popup/dist/index.css'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import '../App.css'
import { Row, Col } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import CommonComponents from './CommonComponents.js'
import { Rate } from 'rsuite'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Typography,
  Rating,
  IconButton,
  Box
} from "@mui/material";
import { MenuItem, FormControl, InputLabel, Select } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// const {id}=useParams();
const AddReview = ({showAddReview,setShowAddReview, tenancyId, customersDetails}) => {
  const [payOnTime, setPayOnTime] = useState()
  const [overallRating, setOverallRating] = useState()
  const [cleanliness, setCleanliness] = useState()
  const [traffic, setTraffic] = useState()
  const [noisy, setNoisy] = useState()
  const [managerComments, setManagerComments] = useState('')
  const [reviewId, setReviewId] = useState('')
  const [customerId, setCustomerId] = useState(
    customersDetails.length>0 ? customersDetails[0].customerId : null)
  const [isAddReview, setIsAddReview] = useState(true)
  const { displayNotificationMessage } = useContext(CommonComponents)
  
  const urlParams = useParams();
  const id = urlParams.id ? urlParams.id : tenancyId;
  
  const navigate = useNavigate()
  const url = process.env.REACT_APP_SERVER_URL

  const getReviewsId = async () => {
    try {
      // await axios
      //   .get(`${url}/getCustomerReviewById/${data.data.isEditReview}`)
      //   .then((responseForReviews) => {
      //     setCleanliness(responseForReviews.data.cleanliness)
      //     setOverallRating(responseForReviews.data.overallRating)
      //     setTraffic(responseForReviews.data.traffic)
      //     setNoisy(responseForReviews.data.noisy)
      //     setManagerComments(responseForReviews.data.managerComments)
      //     setPayOnTime(responseForReviews.data.payOnTime)
      //   })
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    // if (data.data) {
    //   // setReviewId(data.data.isEditReview)
    //   getReviewsId()
    //   setReviewId(data.data.isEditReview)
    // }
    
    console.log(customersDetails)
  }, [])
  const createCustomerReview = async (e) => {
    if (e) e.preventDefault()
    try {
      const tenancyId = id;
      await axios
        .post(`${url}/tenants/${tenancyId}/customerReviews`, {
          tenancyId,
          overallRating,
          managerComments,
          payOnTime,
          cleanliness,
          traffic,
          noisy,
        })
        .then( async(responseForCreatingGuestReview) => {
          console.log(responseForCreatingGuestReview.data)
          if(responseForCreatingGuestReview&& responseForCreatingGuestReview.data){
            const reviewId = responseForCreatingGuestReview.data.reviewId;
            const res = await axios.post(`${url}/customers_reviews`,{
              reviewId,
              customerId
            });
        handleCloseAddReview();
          displayNotificationMessage('success', 'Guest Review Saved!')

            

          }

          
        })
    } catch (error) {
      console.log(error)
    }
  }
  const editCustomerReview = async (e, reviewId) => {
    if (e) e.preventDefault()
    try {
      await axios
        .patch(`${url}/updateCustomerReview/${reviewId}`, {
          overallRating,
          managerComments,
          payOnTime,
          cleanliness,
          traffic,
          noisy,
        })
        .then((responseForUpdatingGuestReview) => {
          // handleCloseAddReview()
          displayNotificationMessage('success', 'Guest Review Updated!')
        })
        handleCloseAddReview();
    } catch (error) {
      console.log(error)
    }
  }

  const deleteCustomerReview = async (e, reviewId) => {
    if (e) e.preventDefault()
    try {
      await axios
        .delete(`${url}/tenants/${id}/customerReviews/${reviewId}`)
        .then((responseForDeletingReview) => {
          console.log(responseForDeletingReview)
        })
    } catch (error) {
      console.log(error)
    }
  }

  const handleCloseAddReview = () => {
    setShowAddReview(false)
  }

  return (
    <>
      <Dialog open={showAddReview} onClose={handleCloseAddReview} maxWidth="sm" fullWidth>
      <DialogTitle>
        {reviewId ? "Update Review" : "Create Review"}
        <IconButton
          aria-label="close"
          onClick={handleCloseAddReview}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
      <Box display="flex" justifyContent="center" mb={1}>
      <FormControl sx={{width:"50%"}} variant="outlined">
      <InputLabel>Select Customer</InputLabel>
      <Select
  label="Select Customer"
  value={customerId}
  onChange={(e) => setCustomerId(e.target.value)}
>
  {customersDetails.map((customer) => (
    <MenuItem key={customer.customerId} value={customer.customerId}>
      {customer.fname + " " + customer.lname}
    </MenuItem>
  ))}
</Select>
    </FormControl>
    </Box>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={6} align="right">
            <Typography variant=""><b>Overall Rating &nbsp;</b></Typography>
          </Grid>
          <Grid item xs={6}>
            <Rating
              value={overallRating}
              onChange={(event, newValue) => setOverallRating(newValue)}
            />
          </Grid>

          <Grid item xs={6} align="right">
            <Typography variant=""><b>Payment On Time &nbsp;</b></Typography>
          </Grid>
          <Grid item xs={6}>
            <Rating
              value={payOnTime}
              onChange={(event, newValue) => setPayOnTime(newValue)}
            />
          </Grid>

          <Grid item xs={6} align="right">
            <Typography variant=""><b>Cleanliness &nbsp;</b></Typography>
          </Grid>
          <Grid item xs={6}>
            <Rating
              value={cleanliness}
              onChange={(event, newValue) => setCleanliness(newValue)}
            />
          </Grid>

          <Grid item xs={6} align="right">
            <Typography variant=""><b>Lack of Traffic &nbsp;</b></Typography>
          </Grid>
          <Grid item xs={6}>
            <Rating
              value={traffic}
              onChange={(event, newValue) => setTraffic(newValue)}
            />
          </Grid>

          <Grid item xs={6} align="right">
            <Typography variant=""><b>Quietness &nbsp;</b></Typography>
          </Grid>
          <Grid item xs={6}>
            <Rating
              value={noisy}
              onChange={(event, newValue) => setNoisy(newValue)}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant=""><b>Manager Comments:</b></Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              variant="outlined"
              value={managerComments}
              onChange={(e) => setManagerComments(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseAddReview} color="secondary">
          Cancel
        </Button>
        {reviewId ? (
          <Button variant="contained" onClick={(e) => editCustomerReview(e, reviewId)} color="primary">
            Update
          </Button>
        ) : (
          <Button variant="contained" onClick={(e) => createCustomerReview(e)} color="primary">
            Submit
          </Button>
        )}
      </DialogActions>
    </Dialog>
    </>
  )
}
export default AddReview
